export default "__VITE_ASSET__0678a4dc__"